import React, { useState } from 'react';
import { Row, Col, FormGroup, Input, Card, Alert, CardBody, CardHeader, Label, Button } from 'reactstrap';
import Select from 'react-select';
import { useService } from '../../../hooks/services/useService';
import { Spinner } from 'reactstrap';

export const IndexReportServices = () => {
    const {
        start_date,
        end_date,
        handleInputChange,
        handleSelectChange,
        DownloadReportService,
        listTypeService,
        id_type_service,
    } = useService();

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [isServiceSelected, setIsServiceSelected] = useState(true); 
    const [isStartDateValid, setIsStartDateValid] = useState(true);
    const [isEndDateValid, setIsEndDateValid] = useState(true);
    const [isDownloadComplete, setIsDownloadComplete] = useState(false);

    const handleDownloadClick = async () => {
        let valid = true;
        if (!id_type_service) {
            setIsServiceSelected(false);
            valid = false;
        } else {
            setIsServiceSelected(true);
        }

        if (!start_date) {
            setIsStartDateValid(false);
            valid = false;
        } else {
            setIsStartDateValid(true);
        }

        if (!end_date) {
            setIsEndDateValid(false);
            valid = false;
        } else {
            setIsEndDateValid(true);
        }

        if (!valid) return;

        setIsButtonDisabled(true);
        setIsDownloading(true);
        setIsDownloadComplete(false);

        await DownloadReportService();

        setIsDownloading(false);
        setIsDownloadComplete(true);

        setTimeout(() => {
            setIsDownloadComplete(false);
            setIsButtonDisabled(false);
        }, 15000);
    }

    return (
        <Col sm="12">
             <Card style={{
                    marginBottom: '15px',
                    background: 'linear-gradient(135deg, #002940 0%, #1d5b83 100%)',
                    border: 'none',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                }}>
                    <CardBody style={{ padding: '18px 25px' }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div style={{
                                    width: '50px',
                                    height: '50px',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '15px'
                                }}>
                                    <img alt="flask" className="img-fluid text-info mr-2" src={require("../../../assets/images/report.png")} style={{ width: "44px", height: "40px" }} />
                                </div>
                                <div>
                                    <h4 className="mb-1" style={{ color: '#fff', fontWeight: 700, fontSize: '17px', textAlign: "justify" }}>
                                        Reporte por servicios
                                    </h4>
                                    <small style={{ color: 'rgba(255,255,255,0.85)', fontSize: '12px' }}>
                                        <i className="fa fa-info-circle mr-1"></i>
                                        Reporte de admisiones por servicio con resultados de estudios clínicos y de laboratorio organizados por paciente
                                        </small>
                                </div>
                            </div>

                        </div>
                    </CardBody>
                </Card>

                <Card
                    className='shadow-sm border height-equal pricingtable mb-0 pb-0'
                    style={{
                        paddingTop: "1px",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                        scrollBehavior: "smooth",
                        transform: "scale(0.9)",
                        width: "113%",
                        transformOrigin: "top left",
                        height: "95%"
                    }}
                    >
                    <Row>

                        <Col md="3" sm="12" className='pt-3'>
                        <Card style={{
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            border: 'none',
                            height: '100%',
                            borderRadius: '12px'
                        }}>
                            <CardHeader style={{
                            background: 'linear-gradient(135deg, #0d3b59 0%, #1d5b83 100%)',
                            color: 'white',
                            padding: '15px',
                            borderRadius: '12px 12px 0 0'
                            }}>
                            <h6 className="mb-0" style={{ fontWeight: 700, fontSize: '15px' }}>
                                <i className="fa fa-filter mr-2"></i>Filtros de Búsqueda
                            </h6>
                            </CardHeader>

                             <CardBody style={{ padding: '20px' }}>
                                    <FormGroup>
                                        <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                            <i className="fa fa-calendar-alt mr-2" style={{ color: '#007bff' }}></i>Fecha de inicio
                                        </Label>
                                        <Input
                                            type="date"
                                            name="start_date"
                                            value={start_date}
                                            onChange={handleInputChange}
                                            className='form-control'
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                padding: '10px',
                                                fontSize: '13px'
                                            }}
                                        />
                                        {!isStartDateValid && (
                                            <Alert color="primary" style={{ marginTop: "5px" }}>
                                                Por favor selecciona la fecha de inicio.
                                            </Alert>
                                        )}
                                    </FormGroup>
                                    <FormGroup>
                                        <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                            <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Fecha de cierre
                                        </Label>
                                        <Input
                                            type="date"
                                            name="end_date"
                                            value={end_date}
                                            onChange={handleInputChange}
                                            className='form-control'
                                            style={{
                                                borderRadius: '8px',
                                                border: '1px solid #ddd',
                                                padding: '10px',
                                                fontSize: '13px'
                                            }}
                                        />
                                        {!isEndDateValid && (
                                            <Alert color="primary" style={{ marginTop: "5px" }}>
                                                Por favor selecciona la fecha de cierre.
                                            </Alert>
                                        )}
                                    </FormGroup>

                                        <FormGroup>
                                        <Label className='f-w-600' style={{ fontSize: '12px', marginBottom: '10px', color: '#333' }}>
                                            <i className="fa fa-calendar-check mr-2" style={{ color: '#28a745' }}></i>Servicios
                                        </Label>

                                        <Select
                                            isClearable={true}
                                            placeholder="Selecciona un servicio"
                                            name="id_type_service"
                                            value={listTypeService.find(option => option.value === id_type_service)}
                                            options={listTypeService}
                                            onChange={(e) => {
                                                handleSelectChange(e);
                                                setIsServiceSelected(true); 
                                            }}
                                            menuPortalTarget={document.body}
                                            styles={{
                                            
                                                option: (base) => ({
                                                    ...base,
                                                    color: '#000', 
                                                }),
                                            }}
                                            noOptionsMessage={() => "Sin Opciones"}
                                            isSearchable={true}  
                                        />
                                        

                                            {!isServiceSelected && (
                                                <Alert color="primary" style={{ marginTop: "1px" }}>
                                                    Por favor selecciona un servicio.
                                                </Alert>
                                            )}
                                    </FormGroup>

                                    <br />
                                    <b>Acciones</b>
                                    <br /><br />
                                    <Button
                                        onClick={handleDownloadClick}
                                        disabled={isButtonDisabled} 
                                        color="primary"
                                        block
                                        outline
                                        className="mb-3"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '6px',
                                            fontSize: '14px',
                                            fontWeight: 600,
                                            borderWidth: '2px'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                    >
                                        {isDownloading ? "Cargando..." : "Descargar"} 
                                    </Button>

                                    
                                </CardBody>
                        </Card>
                        </Col>

                    <Col md="9" sm="12" className='d-flex align-items-center justify-content-center'>
                        <div style={{ textAlign: "center", minHeight: "300px" }}>

                            {/* DESCARGANDO */}
                            {isDownloading && (
                            <>
                                <Spinner color="primary" style={{ width: "4rem", height: "4rem" }} />
                                <br /><br />
                                <label className='f-w-600 f-16 badge badge-light-primary'>
                                Descargando reporte...
                                </label>
                            </>
                            )}

                          
                            {!isDownloading && isDownloadComplete && (
                            <>
                                <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/complete-download.png")}
                                style={{ width: "45%", transition: "0.3s" }}
                                alt="completado"
                                />
                                <br />
                                <label className='f-w-600 f-14 badge badge-light-success'>
                                ¡Descarga completada!
                                </label>
                            </>
                            )}

                            {/* IDLE */}
                            {!isDownloading && !isDownloadComplete && (
                            <>
                                <img
                                src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                style={{ width: "600px", transition: "0.3s" }}
                                alt="idle"
                                />
                                <br />
                                <label className='f-w-600 f-14 badge badge-light-primary'>
                                Reportes por Servicio
                                </label>
                            </>
                            )}

                        </div>
                    </Col>


                    </Row>
                    </Card>

           

           
        </Col>  
    )
};
